<app-dialog-layout class="madar--v2">
  <ng-container dialog-title>{{ 'sharedFeatures.RenewPasswordReminder' | translate }}</ng-container>
  <mat-card dialog-content>
    <mat-card-content >
      <div class="radius-1 p-4 mb-2" [dir]="layoutService.websiteDirection$.value">
        <div class="flex">
          <div class="icon-badge radius-2 flex align-center justify-center mr-6" [style.background]="level.iconBadgeBg">
            <app-icon [name]="level.icon" size="sm" [style.color]="level.badgeBg"></app-icon>
          </div>
          <div class="header-text">
            <h5 class="text-900 h5 m-0 weight-semibold">{{ level.title | translate }}</h5>
            <span class="small" [style.color]="level.badgeBg">{{ daysLabel | translate: level.params }}</span>
            <p class="text-900 mb-4 small">{{ level.body | translate: level.params }}</p>
            <div class="progress-track radius-1 mb-1 overflow-hidden">
              <div class="progress-fill radius-1 h-100" [style.width.%]="progressPercent" [style.background]="level.badgeBg"></div>
            </div>
            <div class="text-400 small flex align-center justify-space-between weight-normal">
              <span>{{ 'sharedFeatures.Expired' | translate }}</span>
              <span>{{ daysRemaining }} / 15 {{ 'sharedFeatures.DaysLeft' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <div class="actions flex wrap justify-flex-end mt-2">
    <button mat-button class="btn-remind py-2 px-4 text-primary bg-primary-light mr-2" (click)="onRemindLater()">
      <span class="small">{{ 'sharedFeatures.RemindMeLater' | translate }}</span>
    </button>
    <button mat-button class="btn-renew py-2 px-4 bg-primary brd-none text-white" (click)="onRenew()">
      <span class="small">{{ 'sharedFeatures.RenewNow' | translate }}</span>
    </button>
  </div>
</app-dialog-layout>
